// src/pages/income/env/total/IncomeEnvTotalDraftPreviewWindow.jsx
// ✅ 환경/종합 미리보기 새 창 라우트 element — 얇은 래퍼.
import React from "react";
import IncomeDraftPreviewWindow from "../../_shared/IncomeDraftPreviewWindow";
import incomeEnvTotalDraftConfig from "./incomeEnvTotalDraftConfig";

export default function IncomeEnvTotalDraftPreviewWindow() {
  return <IncomeDraftPreviewWindow config={incomeEnvTotalDraftConfig} />;
}
